"use client";

import React from "react";

import Page from "@/components/ui/page";
import Section from "@/components/ui/section";
import { tinaFieldSafe, useTina } from "@/utils";
import Header from "@/components/Header";
import CallToAction from "@/components/CallToAction";
import Video from "@/components/Video";
import { Card, CardContent } from "@/components/ui/card";
import BookDemoForm from "@/components/BookDemoForm";
import LogosCarousel from "@/components/LogosCarousel";

export default function BookDemo(props) {
  const { data } = useTina({
    query: props.query,
    variables: props.variables,
    data: props.data,
  });

  const header = data?.bookDemo?.header;
  const formSection = data?.bookDemo?.formSection;
  const videoSection = data?.bookDemo?.videoSection;
  const callToAction = data?.bookDemo?.cta;

  const featuredVideo = videoSection?.video;

  return (
    <Page
      defaultTinaField={data?.bookDemo}
      seo={data?.bookDemo?.seo}
      pagePath="/book-demo"
      titleFallback="Book a Demo"
    >
      <Header
        {...header}
        variant="left"
        backgroundVariant="pixels-l-r"
        wrapperClassName="pb-40 md:pb-64 [&_h1]:lg:!text-5xl [&>div:last-child]:grid [&>div:last-child]:lg:grid-cols-2 [&>div:last-child]:gap-8 [&>div:last-child]:grid-rows-[auto_1fr] [&>div]:lg:!gap-12 [&>div]:lg:!gap-16"
      >
        <Card
          animateOnHover={false}
          wrapperClassName="row-span-2 max-md:order-2"
          backgroundVariant="default"
          className="!py-4"
        >
          <CardContent>
            <BookDemoForm formSection={formSection} />
          </CardContent>
        </Card>
        {header?.benefits && (
          <div className="space-y-6 max-md:order-1">
            {header?.benefits?.map((benefit, index: number) => (
              <div key={index}>
                <h3
                  className="h5"
                  data-tina-field={tinaFieldSafe(benefit, "title")}
                >
                  {benefit.title}
                </h3>
                <p data-tina-field={tinaFieldSafe(benefit, "description")}>
                  {benefit.description}
                </p>
              </div>
            ))}
          </div>
        )}
      </Header>
      <LogosCarousel />
      <Section wrapperClassName="" className="space-y-8">
        <div className="space-y-3">
          <h2
            className="h3"
            data-tina-field={tinaFieldSafe(videoSection, "title")}
          >
            {videoSection?.title}
          </h2>
          <p data-tina-field={tinaFieldSafe(videoSection, "description")}>
            {videoSection?.description}
          </p>
        </div>
        {featuredVideo && (
          <Video
            video={featuredVideo}
            variant="card"
            size="md"
            animateOnHover={false}
            playInDialog={false}
          />
        )}
      </Section>
      <CallToAction
        {...callToAction}
        variant="left"
        backgroundVariant="dots"
      />
    </Page>
  );
}
